document.addEventListener("turbolinks:load", function() {
  $(document).on("change","select[data-update-from-select]", function() {
    $.post($(this).data("update-from-select") + "?selection=" + $(this).val());
  });
})
